/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const CircleWithCircleInMiddleIconOutline = createIcon({
  displayName: 'CircleWithCircleInMiddleIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.8284 9.17157c1.5621 1.5621 1.5621 4.09476 0 5.65685 -1.5621 1.5621-4.09476 1.5621-5.65685 0 -1.5621-1.5621-1.5621-4.09476-1.77636e-15-5.65685 1.5621-1.5621 4.09476-1.5621 5.65685-1.77636e-15"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18.364 5.63604c3.51472 3.51472 3.51472 9.2132 0 12.7279 -3.51472 3.51472-9.2132 3.51472-12.7279 0 -3.51472-3.51472-3.51472-9.2132-1.77636e-15-12.7279 3.51472-3.51472 9.2132-3.51472 12.7279-1.77636e-15"
        ></path>
      </g>
    </>
  ),
})

const CircleWithCircleInMiddleIconFilled = createIcon({
  displayName: 'CircleWithCircleInMiddleIconFilled',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <Box
          as="path"
          fill="primary.500"
          d="M14.8284 9.17157c1.5621 1.5621 1.5621 4.09476 0 5.65685 -1.5621 1.5621-4.09476 1.5621-5.65685 0 -1.5621-1.5621-1.5621-4.09476-1.77636e-15-5.65685 1.5621-1.5621 4.09476-1.5621 5.65685-1.77636e-15"
        ></Box>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18.364 5.63604c3.51472 3.51472 3.51472 9.2132 0 12.7279 -3.51472 3.51472-9.2132 3.51472-12.7279 0 -3.51472-3.51472-3.51472-9.2132-1.77636e-15-12.7279 3.51472-3.51472 9.2132-3.51472 12.7279-1.77636e-15"
        ></path>
      </g>
    </>
  ),
})

const CircleWithCircleInMiddle: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'filled':
      return <CustomIcon as={CircleWithCircleInMiddleIconFilled} {...props} />
    default:
      return <CustomIcon as={CircleWithCircleInMiddleIconOutline} {...props} />
  }
}

export default memo(CircleWithCircleInMiddle)
